// Tier copy, keyed by CourseType then CourseIntensity (see app/data/pricing.ts).
const ar = {
  tierNames: {
    light: "خفيف",
    semiIntensive: "شبه مكثّف",
    intensive: "مكثّف",
  },

  groupCourses: {
    light: {
      description: "دورة مناسبة للمبتدئين بجدول أخفّ.",
      features: [
        "حصص مباشرة عبر الإنترنت مرة أسبوعيًا",
        "جلسات أسئلة وأجوبة بعد كل حصة",
        "الوصول إلى الجلسات المسجّلة",
        "توجيه مهني كل 3 أشهر",
        "شهادة إتمام",
        "الوصول إلى مجموعة المجتمع",
        "تقارير تقدّم شهرية",
      ],
    },
    semiIntensive: {
      description: "تفاعل أكبر مع حصص مباشرة إضافية ومحتوى مهني.",
      features: [
        "حصص مباشرة عبر الإنترنت مرتين أسبوعيًا",
        "جلسات أسئلة وأجوبة بعد كل حصة",
        "الوصول إلى الجلسات المسجّلة",
        "توجيه مهني شهري",
        "تحضير لمقابلات العمل (كل شهرين)",
        "مشاريع جماعية مع ملاحظات",
        "مواد ومصادر دراسية",
      ],
    },
    intensive: {
      description: "أكثر الدورات الجماعية غمرًا مع إرشاد شخصي.",
      features: [
        "حصص مباشرة عبر الإنترنت أربع مرات أسبوعيًا",
        "جلسات أسئلة وأجوبة بعد كل حصة",
        "الوصول إلى الجلسات المسجّلة",
        "توجيه مهني كل أسبوعين",
        "تحضير لمقابلات العمل (شهريًا)",
        "مشاريع جماعية مع إرشاد",
        "ندوات وورش عمل حصرية",
      ],
    },
  },

  individualCourses: {
    light: {
      description: "دورة مرنة بخطط مصمّمة خصيصًا وتفاعل معتدل.",
      features: [
        "خطة تعلّم مصمّمة خصيصًا",
        "حصص مباشرة عبر الإنترنت مرة أسبوعيًا",
        "أسئلة وأجوبة بعد كل حصة",
        "الوصول إلى الجلسات المسجّلة",
        "توجيه مهني كل 3 أشهر",
        "ملاحظات فردية على المشاريع",
        "مواد ومصادر دراسية",
      ],
    },
    semiIntensive: {
      description: "تفاعل فردي أكثر تكرارًا وإرشاد من الخبراء.",
      features: [
        "خطة تعلّم مصمّمة خصيصًا",
        "حصص مباشرة عبر الإنترنت مرتين أسبوعيًا",
        "أسئلة وأجوبة بعد كل حصة",
        "توجيه مهني شهري",
        "إرشاد على المشاريع وملاحظات من الخبراء",
        "تحضير لمقابلات العمل (شهريًا)",
        "مواد دراسية ذات أولوية",
      ],
    },
    intensive: {
      description: "برنامج متكامل مع إرشاد ودعم من الخبراء.",
      features: [
        "خطة تعلّم مصمّمة خصيصًا",
        "حصص مباشرة عبر الإنترنت أربع مرات أسبوعيًا",
        "أسئلة وأجوبة بعد كل حصة",
        "توجيه مهني كل أسبوعين",
        "إرشاد معمّق على المشاريع",
        "تحضير لمقابلات العمل (كل أسبوعين)",
        "دعم عبر البريد الإلكتروني والدردشة بأولوية",
      ],
    },
  },
};

export default ar;
